import { identityApiRef, useApi } from '@backstage/frontend-plugin-api';
import { useCallback, useState } from 'react';

/**
 * Signs the user out of the portal.
 *
 * `identityApi.signOut()` clears the provider session and then navigates to the
 * app base URL, so the promise never resolves on the happy path — `pending`
 * exists to keep the trigger disabled during that window and is only reset when
 * sign-out actually fails.
 */
export const useSignOut = () => {
  const identityApi = useApi(identityApiRef);
  const [pending, setPending] = useState(false);
  const [error, setError] = useState<string | undefined>();

  const signOut = useCallback(async () => {
    setPending(true);
    setError(undefined);
    try {
      await identityApi.signOut();
    } catch (err: unknown) {
      setError(
        err instanceof Error ? err.message : 'Could not sign out. Try again.',
      );
      setPending(false);
    }
  }, [identityApi]);

  return { signOut, pending, error };
};
